import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export interface AuthRequiredProps {
  [x: string]: any
}

export const AuthRequired: FC<AuthRequiredProps> = ({
  children,
}: AuthRequiredProps) => {
  const token = sessionStorage.getItem('token')
  const navigate = useNavigate()

  useEffect(() => {
    if (!token || token === 'undefined' || token === '') {
      // Redirect user to login page if Token doesn't exist
      navigate('/auth/login')
      // navigate('/')
    }
  }, [sessionStorage])

  return children
}

export default AuthRequired
